import { useEffect, useState } from 'react';
import { useIsMounted } from 'usehooks-ts';

import i18n from '@app/i18n/i18n';
import { lazyI18nResources } from '@app/i18n/lazyResources';
import { log } from '@app/shared/utils/logger';

interface I18nModule {
  default: Record<string, unknown>;
}

export const useDynamicTranslationNamespace = (namespace: string) => {
  const [loaded, setLoaded] = useState(false);
  const isMounted = useIsMounted();
  const lng = i18n.language;

  useEffect(() => {
    const load = async () => {
      setLoaded(false);

      if (i18n.hasResourceBundle(lng, namespace)) {
        setLoaded(true);
        return;
      }

      const key = `/src/app/i18n/${lng}/${namespace}.json`;
      const loader = lazyI18nResources[key];
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!loader) {
        const error = new Error(`[i18n] Missing resource: ${key}`);
        void log({ level: 'error', error });
        return;
      }

      try {
        const mod = (await loader()) as I18nModule;
        i18n.addResourceBundle(lng, namespace, mod.default, true, true);
      } catch (error: unknown) {
        void log({ level: 'error', message: 'i18 error', error });
        return;
      }

      if (isMounted()) {
        setLoaded(true);
      }
    };

    void load();
  }, [lng, namespace, isMounted]);

  return loaded;
};
